import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import { Provider } from 'react-redux'; // Import Provider from react-redux
import AppRoutes from "./route/AppRoute";
import themeConfig from "./themeConfig";
import store from "./redux/store/store";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import './App.css';
const queryClient = new QueryClient()

function App() {
  return (
    <QueryClientProvider client={queryClient}>
    <Provider store={store}> {/* Wrap the application with Provider to give access to Redux store */}
      <ThemeProvider theme={themeConfig}>
        <Router>
          <AppRoutes /> 
        </Router>
      </ThemeProvider>
    </Provider>
    </QueryClientProvider>
  );
}

export default App;
